import * as THREE from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { fikoObjeyiStepIndir, fikoStepAyarlariniDuzenle } from './FikoSTEPDisaAktar';

export class FikoCizimFBX extends FikoGrup {
    override type: any = "FikoCizimFBX";
    /** */
    sayac = 1;

    override komutlar = [
        {
            isim: "Gizle / Göster",
            simge: "eye",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            isim: "STEP olarak indir (B-Rep)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'brep', this.name); }
                catch (e: any) {
                    console.error('STEP (B-Rep) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP olarak indir (AP242 Tessellated)",
            simge: "download",
            tiklandi: async () => {
                try { await fikoObjeyiStepIndir(this, 'tessellated', this.name); }
                catch (e: any) {
                    console.error('STEP (Tessellated) disa aktarim hatasi', e);
                    alert('STEP olarak aktarilamadi: ' + (e?.message || e));
                }
            }
        },
        {
            isim: "STEP ayarları...",
            simge: "cog",
            tiklandi: () => { fikoStepAyarlariniDuzenle(); }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/fbx.webp";
    }

    dosyadan(dosya: any) {
        let _this = this;
        var material = new THREE.MeshPhongMaterial({
            color: 0x0000fa, side: THREE.DoubleSide, shadowSide: THREE.DoubleSide, polygonOffset: true,
            polygonOffsetFactor: 1, // positive value pushes polygon further away
            polygonOffsetUnits: 1
        });

        const loader: FBXLoader = new FBXLoader();

        loader.load(URL.createObjectURL(dosya), function (geometry: THREE.Group) {

            for (let index = 0; index < geometry.children.length; index++) {
                const element: THREE.Mesh = geometry.children[index] as THREE.Mesh;

                var edge: THREE.EdgesGeometry = new THREE.EdgesGeometry(element.geometry);
                var edgeLine = new THREE.LineSegments(edge, new THREE.LineBasicMaterial({ color: 0x000000 }));
                edgeLine.renderOrder = 1;
                element.add(edgeLine)

                _this.add(element)
            }
            _this.sahne.anaGosterim.FikoYT.degisti.emit();

        });
        return this;
    }

}